import Swal from 'sweetalert2';

const showModal = async (title = '¡UPS!', text = 'Ocurrió un error inesperado', type = 'error', extra = null) => {
    const htmlTitle = `<h5 class='font-semibold text-2xl text-primary md:mt-4 md-3'>${title}</h5>`;
    let defaultOptions = {
        title: htmlTitle,
        showCloseButton: true,
        confirmButtonColor: '#7C1338',
        background: '#F7F4EA',
        showClass: {
            popup: ''
        },
        hideClass: {
            popup: 'swal2-hide'
        }
    };

    let options = defaultOptions;
    if (extra !== null) {
        options = { ...defaultOptions, ...extra };
    }

    let response = null;
    if (text === '') {
        response = await Swal.fire(options);
    } else {
        response = await Swal.fire({ ...options, ...{ text: text } });
    }

    return response;
}

const isEmpty = (e) => {
    return e === undefined || e === null || e === 0 || e === '0' || e.length === 0 || e === '';
}

const isset = (e) => {
    return e !== undefined && e !== null;
}

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

const isValidDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    const [year, month, day] = dateString.split("-").map(Number);

    const date = new Date(year, month - 1, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
}

async function copyText(texto) {
    await navigator.clipboard.writeText(texto);
}

export { showModal, isEmpty, isset, scrollToTop, isValidDate, copyText }